const userInfo = {
  state: {
    userInfo: null
  },
  mutations: {
    USERINFO (state, info) {
      if (info) {
        state.userInfo = info
      } else {
        state.userInfo = null
      }
    }
  },
  getters: {
    userInfo: state => state.userInfo
  }
}

export default userInfo
